import { useEffect, useState } from "react";
import { socket } from "../socket";
import Actions from "../Actions";
import logger from "../utils/LoggerFrontend";
import { createShutterstockQuery } from "../PagesUser/SelfServiceCampaignCreation/Previews/helpers";

let executeFallback = true;
let timeoutId = "";

// Search into Shutterstock API with a keywords query
function useSearchByKeywords({
  requestId,
  defaultSearch,
  fallbackSearch,
  keywords,
  shutterStockAPIVersion,
  setIsKeywordsPresent
}) {
  const [keywordsSearched, setKeywordsSearched] = useState(false);

  useEffect(() => {
    if (!requestId || keywords?.length) {
      return;
    }

    socket.connect();
    socket.emit("JOIN_ROOM", requestId);

    logger.log("useSearchByKeywords", "socket connected", { id: socket.id, requestId });

    timeoutId = setTimeout(() => {
      socket.disconnect();

      if (!executeFallback) {
        return;
      }

      setIsKeywordsPresent(false);
      logger.log("useSearchByKeywords", "Requesting fallback function");
      Actions.searchShutterstockImagesAPI({
        defaultSearch,
        fallbackSearch,
        keywords: false,
        search: defaultSearch,
        version: shutterStockAPIVersion
      });
    }, 10000);

    socket.on("KEYWORDS_UPDATED", (keywords) => {
      logger.log("useSearchByKeywords", "Received new search by keywords message", {
        id: socket.id,
        keywords
      });

      const search = createShutterstockQuery(keywords);

      if (keywordsSearched || !search) {
        return;
      }

      Actions.searchShutterstockImagesAPI({
        defaultSearch,
        fallbackSearch,
        keywords: true,
        search,
        version: shutterStockAPIVersion
      });

      setIsKeywordsPresent(true);
      setKeywordsSearched(true);
      executeFallback = false;

      clearInterval(timeoutId);
    });

    return () => socket.disconnect();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    defaultSearch,
    fallbackSearch,
    keywords,
    keywordsSearched,
    requestId,
    setKeywordsSearched,
    shutterStockAPIVersion
  ]);
}

export default useSearchByKeywords;
